// extracted by mini-css-extract-plugin
export var card = "sectionPricingCards-module--card--16cb6";
export var cards = "sectionPricingCards-module--cards--e059e";
export var logos = "sectionPricingCards-module--logos--32eed";
export var richtext = "sectionPricingCards-module--richtext--bde4c";
export var section = "sectionPricingCards-module--section--2ed48";
export var toggle = "sectionPricingCards-module--toggle--1dcc8";